export function resolveSharePointScope(url: string, apiPermission: string) {
    const valueAsUrl = new URL(url);
    const scope = `offline_access ${valueAsUrl.origin}/${apiPermission}`;
    return scope;
  }
